export default {
    menu: [
        {
            image: 'partite.webp',
            icon: 'fas fa-futbol',
            section: 'Scegli partite',
            submenu: [
                {
                    route: 'event.index',
                    label: 'Scelta ZikiPro'
                },
                {
                    route: 'event.classic',
                    label: 'Scelta classica'
                }
            ]
        },
        {
            image: 'sfida.webp',
            icon: 'fas fa-trophy',
            section: 'La sfida',
            submenu: [
                {
                    route: 'challenge.list',
                    label: 'Lista Sfide'
                },
                {
                    route: 'challenge.ranking',
                    label: 'Classifiche Sfide'
                },
                {
                    route: 'challenge.howto',
                    label: 'Come si guadagna'
                }
            ]
        },
        {
            image: 'giocata.webp',
            icon: 'far fa-list-alt',
            section: 'La mia giocata',
            submenu: [
                {
                    route: 'bill.index',
                    label: 'Archivio giocate'
                }
            ]
        },
        {
            image: 'salvaerrori.webp',
            icon: 'fas fa-shield-alt',
            section: 'Salva errori',
            submenu: [
                {
                    route: 'system.index',
                    label: 'Sistemi salva errori'
                }
            ]
        },
        {
            image: 'note.webp',
            icon: 'far fa-clipboard',
            section: 'Blocco Note',
            submenu: [
                {
                    route: 'bookmark.index',
                    label: 'Eventi salvati'
                }
            ]
        },
        {
            image: 'pronostici.webp',
            icon: 'fas fa-chart-line',
            section: 'Pronostici',
            submenu: [
                {
                    route: 'score.index',
                    label: 'Ricerca pronostici'
                },
            ]
        },
        {
            image: 'amici.webp',
            icon: 'fas fa-user-friends',
            section: 'Community',
            submenu: [
                {
                    route: 'community.search',
                    label: 'Cerca amici'
                },
                {
                    route: 'community.friends',
                    label: 'I miei amici'
                },
                {
                    route: 'community.bills',
                    label: 'Le giocate degli amici'
                },
                {
                    route: 'messages.index',
                    label: 'Messaggi'
                },
            ]
        },
        {
            image: 'gruppi.webp',
            icon: 'fas fa-users',
            section: 'Gruppi',
            submenu: [
                {
                    route: 'group.index.me',
                    label: 'I miei gruppi'
                },
                {
                    route: 'group.index',
                    label: 'Elenco gruppi'
                },
            ]
        },
    ],
};
